let React = require('react');

let TitularTarjeta = React.createClass({
    render: function () {
        return (
            <option id={this.props.row.Id} value={this.props.row.Nombre + " " + this.props.row.Apellido}
                key={this.props.Key} >{this.props.row.TipoDocumentoCodigo} {this.props.row.NumeroDocumento} - CUIT {this.props.row.Cuit}</option>
        );
    },
});

export default TitularTarjeta